// extracted by mini-css-extract-plugin
module.exports = {"logoImage":"header_logo_image-module--logoImage--2qyMT"};